<template>
  <div class="ac-card-content">
    <div class="ac-header-container justify-between">
      <div class="ac-header">
        Delete Address
      </div>
      <button
        class="ac-close-button"
        @click="toggle(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div class="ac-body-text">
        Are you sure you want to delete this address? This cannot be undone.
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="address-icn-btn"
        @click="toggle(false)"
      >
        Cancel
      </button>
      <button
        class="address-del-btn"
        @click="updatePartnerConfig"
      >
        Delete
      </button>
    </div>
    <ProcessOverlay
      :show="updating"
      text="Deleting"
    />
  </div>
</template>

<script>
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'DeleteShippingAddressPopup',
  components: {
    ProcessOverlay,
  },
  props: {
    toggle: Function,
    states: Array,
    address: Object,
    update: Function,
  },
  data() {
    return {
      updating: false,
    };
  },
  methods: {
    async updatePartnerConfig() {
      this.updating = true;
      await this.update({
        ...this.address,
        status: 'Deleted',
      });
      this.updating = false;
      this.$store.dispatch('showSuccessToast', {
          message: `Address ${this.address.address1} was deleted`,
        });
      this.toggle(false);
    },
  },
};
</script>

<style lang="scss" scoped>

.ac-body-container {
  text-align: center;

  .ac-body-text {
    font-size: 1.125rem;
    font-weight: 400;
  }

  .ac-body-header {
    margin-top: 12px;
    font-size: 1.25rem;
    font-weight: 500;
  }
}

.ac-form-button:nth-child(2) {
  background-color: $TOMATO100;
}
</style>
